import { giphyBlue, giphyDarkCharcoal, giphyDarkGrey, giphyLightBlue, giphyLightCharcoal } from '@giphy/colors'
import styled, { css } from 'styled-components'
import RangeSlider, { CreationToolsRangeSliderProps } from '.'

const SliderGradientContent = styled.div<{ selected?: boolean }>`
    height: calc(100% + 12px);
    margin-top: -6px;

    width: calc(100% + 32px);
    margin-left: -16px;

    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: bold;
    background: linear-gradient(-180deg, ${giphyLightCharcoal} 0%, ${giphyDarkCharcoal});
    pointer-events: none;
    border-radius: 6px;

    ${({ selected }) =>
        selected &&
        css`
            background: linear-gradient(45deg, ${giphyBlue} 0%, ${giphyLightBlue} 100%) !important;
        `}
`

const Slider = styled(RangeSlider)`
    background: ${giphyDarkGrey};
    border-radius: 6px;
    min-height: 42px;

    div {
        background-color: transparent !important;
    }
`

type StyledRangeSliderProps = {
    selected?: boolean
}

const StyledRangeSlider = (props: CreationToolsRangeSliderProps & StyledRangeSliderProps) => (
    <Slider {...props}>
        <SliderGradientContent selected={props.selected}>{props.children}</SliderGradientContent>
    </Slider>
)

export default StyledRangeSlider
